import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=46a1803e&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46a1803e')) {
      api.createRecord('46a1803e', component.options)
    } else {
      api.reload('46a1803e', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=46a1803e&", function () {
      api.rerender('46a1803e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2m5Qwtv0T70tC/JS/comp/ImgFallback.vue"
export default component.exports